<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">템플릿 만들기</h4>
        </template>
        <div class="row">
          <label class="col-sm-2 col-form-label">적용 템플릿 타입</label>
          <div class="col-sm-10 checkbox-radios">
            <span v-for="(n, index) in types" :key="index">
              <base-radio :name="n.value.toString()" inline v-model="type">{{ n.label }}</base-radio>
            </span>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">템플릿 제목</label>
          <div class="col-sm-10">
            <base-input placeholder="제목" v-model="title">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">템플릿 양식</label>
          <div class="col-sm-10">
            <base-input placeholder="내용">
              <textarea class="form-control" rows="20" v-model="contents" />
            </base-input>
          </div>
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, Card } from "@/components/index";
import { TemplateTypes } from "@/pages/TemplateManage/TemplateType";

export default {
  components: {
    Card,
    BaseInput,
  },
  async created() {
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id);
      await this.getTemplateById();
    }
  },
  data() {
    return {
      title: null,
      contents: null,
      types: TemplateTypes,
      type: null,
      isVisible: true,
    };
  },
  methods: {
    async getTemplateById() {
      return this.$axios.get(`/templates/${this.id}`).then((res) => {
        const data = res.data.data;
        if (data) {
          this.type = data.type;
          this.title = data.title;
          this.contents = data.contents;
        }
      });
    },

    async onSubmit() {
      const param = {
        type: this.type,
        title: this.title,
        contents: this.contents,
      };

      if (!this.title) {
        Toast.error("제목을 입력해주세요");
        return;
      }
      if (!this.type) {
        Toast.error("타입을 선택해주세요");
        return;
      }
      if (!this.contents) {
        Toast.error("내용을 입력해주세요");
        return;
      }

      if (this.id) {
        return this.$axios.put(`/templates/${this.id}`, param).then((res) => {
          Toast.success("등록되었습니다");
          this.$router.go(-1);
        });
      } else {
        return this.$axios.post(`/templates`, param).then((res) => {
          Toast.success("등록되었습니다");
          this.$router.go(-1);
        });
      }
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.bootstrap-switch {
  margin: 6px;
}
</style>
